// extracted by mini-css-extract-plugin
export var htmlPreview = "_v4-0";